// Content page loaders - blog, settings, and other main site functionality
// These wrapper functions import and execute the actual loaders

export const randomBlogArticlesLoader = async (args: any) => {
    const {redirectIfLoggedIn} = await import("../util/AuthUtil");
    const redirectResponse = await redirectIfLoggedIn();
    if (redirectResponse) return redirectResponse;

    const module = await import("../pages/Index");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const blogArticlesLoader = async (args: any) => {
    const module = await import("../pages/user/blog/BlogPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const blogArticleLoader = async (args: any) => {
    const module = await import("../pages/user/blog/BlogPostPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const settingsLoader = async (args: any) => {
    const module = await import("../pages/user/settings/SettingsPage");
    return module.settingsLoader ? await (module.settingsLoader as any)(args) : null;
};

export const threadsLoader = async (args: any) => {
    const module = await import("../components/user/ai/chat/Chat");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const isLoggedInLoader = async (args: any) => {
    const module = await import("../util/Loader");
    return module.isLoggedInLoader ? await (module.isLoggedInLoader as any)(args) : null;
};

export const prelaunchContentLoader = async (args: any) => {
    const module = await import("../util/Loader");
    return module.isLoggedInLoader ? await (module.isLoggedInLoader as any)(args) : null;
};

export const parentStartLoader = async (args: any) => {
    const module = await import("../pages/parent-start/ParentStartPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const childMeetingLoader = async (args: any) => {
    const module = await import("../pages/parent-start/ChildMeetingPage");
    return module.loader ? await (module.loader as any)(args) : null;
};